module.exports = __webpack_public_path__ + "img/18_Antrum+LC.9b38a18d.png";